import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetInvoiceList,setGetUserList,setGetSingleInvoice } from "../reusable/reusableSlice";


export const getInvoiceList = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("invoice/get_all",data);
      if (response?.data) {
        dispatch(setGetInvoiceList(response?.data?.response))
      } else {
        dispatch(setGetInvoiceList([]))
      }
      return response
    } catch (err) {
      console.error(err);
      dispatch(setGetInvoiceList([]))
    }
  };

export const updateInvoiceAccountingClassification =
  (id, isTestingDocument) => async () => {
    try {
      return await axiosInstance.post(
        `invoice/${id}/accounting-classification`,
        {
          is_testing_document: isTestingDocument ? 1 : 0,
        }
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  export const addinvoice = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("invoice/create", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        data.invoice_type === 3
          ? navigate("/invoice?invoice_type=3")
          : data.invoice_type === 4
          ? navigate("/invoice?invoice_type=4")
          : navigate("/invoice")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  export const addinvoicesData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("invoice/create", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        data.invoice_type === 3 ? navigate("/creditnoteslists") : data.invoice_type === 4 ?  navigate("/debitnoteslists") : navigate("/invoices")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  export const getSingleIdInvoice = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`invoice/get_byid/${id}`);
      console.log(response,"response")
      if (response?.data) {
        dispatch(setGetSingleInvoice(response?.data?.response))
      } else {
        dispatch(setGetSingleInvoice([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSingleInvoice([]))
    }
  };

  export const updateInvoiceList = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("invoice/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/invoice")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const deleteOneInvoice = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.delete(`invoice/delete/${id}/1`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
      }
     
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  export const getUserList = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("user/get_all",data);

      if (response?.data) {
        dispatch(setGetUserList(response?.data?.response))
      } else {
        dispatch(setGetUserList([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetUserList([]))
    }
  };

  export const UpdatedeleteOneInvoice = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.delete(`invoice/delete/${id}/2`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
